import React, { useState } from 'react';
import styles from './DevPanel.module.css';

const DevPanel: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <div className={styles.devPanel}>
      <button
        className={styles.toggle}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle developer panel"
      >
        <i className="fas fa-cog" />
      </button>

      {isOpen && (
        <div className={styles.panel}>
          <h3 className={styles.title}>Developer Panel</h3>
          <div className={styles.info}>
            <p><strong>Phase 6:</strong> Integration & Polish</p>
            <p><strong>Status:</strong> Testing component modularity</p>
          </div>
          <div className={styles.instructions}>
            <h4>Component Testing:</h4>
            <ol>
              <li>Edit <code>public/config.json</code></li>
              <li>Set component's <code>enabled: false</code></li>
              <li>Refresh to see component hidden</li>
              <li>Verify layout still looks good</li>
            </ol>
          </div>
          <div className={styles.checklist}>
            <h4>Phase 6 Progress:</h4>
            <label>
              <input type="checkbox" checked readOnly /> Components integrated
            </label>
            <label>
              <input type="checkbox" /> Component enable/disable tested
            </label>
            <label>
              <input type="checkbox" /> Responsive design verified
            </label>
            <label>
              <input type="checkbox" /> Animation performance checked
            </label>
            <label>
              <input type="checkbox" /> All micro-interactions polished
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default DevPanel;